module.exports = __webpack_public_path__ + "static/media/Helios_DCEE.cc6832e4.png";